var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:{'my-nav-bar': true, 'bordered': _vm.bordered, 'fixed': _vm.fixed},style:({
             ..._vm.style,
             'background': this.background,
             'color': this.textColor})},[(_vm.$route.path!='/audio/list')?_c('div',{staticClass:"left",on:{"click":_vm.getBack}},[_vm._t("left",function(){return [_c('span',{staticClass:"iconfont icon-xitongfanhui"})]})],2):_vm._e(),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"right"},[_vm._t("right")],2)]),(_vm.fixed)?_c('div',{staticClass:"place"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }